var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolana = function SvgSolana(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6032F5",
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.672 21.675a.527.527 0 0 1 .396-.175l12.219.01c.052 0 .103.015.146.044a.265.265 0 0 1 .118.268.27.27 0 0 1-.066.138l-2.602 2.865a.536.536 0 0 1-.397.175l-12.218-.01a.261.261 0 0 1-.146-.044.265.265 0 0 1-.118-.268.27.27 0 0 1 .066-.138l2.602-2.865Zm12.813-2.385a.27.27 0 0 1-.198.45l-12.219.01a.537.537 0 0 1-.396-.175l-2.602-2.867a.262.262 0 0 1-.066-.138.268.268 0 0 1 .264-.312l12.219-.01a.537.537 0 0 1 .396.176l2.602 2.866Zm-12.813-8.115a.527.527 0 0 1 .396-.175l12.219.01c.052 0 .103.015.146.044a.265.265 0 0 1 .118.268.27.27 0 0 1-.066.138l-2.602 2.865a.536.536 0 0 1-.397.175l-12.218-.01a.261.261 0 0 1-.146-.044.265.265 0 0 1-.118-.268.27.27 0 0 1 .066-.138l2.602-2.865Z"
  }))));
};
export default SvgSolana;